import { AuthApi } from '@reposit/api-client';
import axios from 'axios';
import { appConfig } from '../../../appConfig';

export type AdminLoginAuthMode = { kind: 'password_only' } | { kind: 'google_only' } | { kind: 'google_with_password' };

export type LoginPageError = 'google_login_failed';

export function parseAdminLoginAuthMode(wireMode: string): AdminLoginAuthMode {
  if (wireMode === 'google_only') {
    return { kind: 'google_only' };
  }
  if (wireMode === 'google_with_password') {
    return { kind: 'google_with_password' };
  }
  return { kind: 'password_only' };
}

export async function loadAdminLoginAuthMode(): Promise<AdminLoginAuthMode> {
  const authApi = new AuthApi({}, appConfig.api.basePath, axios);
  const { data } = await authApi.getAdminLoginAuthMode();
  return parseAdminLoginAuthMode(data.mode);
}

export function adminGoogleOAuthStartUrl(apiBasePath: string, returnPath?: string): string {
  const base = apiBasePath.replace(/\/$/, '');
  const url = new URL(`${base}/v2/auth/admin-google/start`);
  if (returnPath) {
    url.searchParams.set('state', returnPath);
  }
  return url.toString();
}

export function beginAdminGoogleLogin(returnPath?: string): void {
  window.location.assign(adminGoogleOAuthStartUrl(appConfig.api.basePath, returnPath));
}

export function readLoginPageError(search: string): LoginPageError | null {
  const query = search.startsWith('?') ? search.slice(1) : search;
  const error = new URLSearchParams(query).get('error');
  return error === 'google_login_failed' ? 'google_login_failed' : null;
}
